pageLoad('agreements_index', 'bills_index', 'payment_methods_edit', () => {
  // send message if payment succeeded
  if (window.ReactNativeWebView != null) {
    window.ReactNativeWebView.postMessage('payment_success');
  }
});
